import React, { useCallback } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
export const Modal = ({ children, show, size, backdrop, isError, keyboard, setShow, className, }) => {
    const handleClose = useCallback(() => {
        setShow(false);
    }, [setShow]);
    return (React.createElement(BootstrapModal, { size: size, show: show, onHide: handleClose, backdrop: 'static', keyboard: keyboard, dialogClassName: isError ? 'modal-error' : undefined, className: className }, children));
};
//# sourceMappingURL=Modal.js.map